import geo from '@/geo'

// Re-sorts contiguous runs of location content blocks once the visitor's
// position is known. A run is a maximal stretch of adjacent location blocks;
// only a different kind of block (title, text, image) divides one run from the
// next, so the page structure is preserved but the list of locations is free to
// reorder within itself. Inside a run, the blocks that have coordinates sort
// closest-first to the top; coordinate-less location blocks ("Multiple
// locations", labels like "Event") have no distance, so they sink to the bottom
// of the run keeping their original order - they do NOT split the run.
//
// The sort key is the same distance the line displays: the driving miles once
// they resolve (so a US visitor's list matches the "1197 miles" they read),
// falling back to straight-line miles until then / where drive time isn't
// available (non-US). Keying off drive miles matters because road-distance
// ranking differs from straight-line ranking - sorting by haversine while
// showing road miles makes the list look unsorted. It is the "distance", never
// the drive "time".
export default {

	methods: {

		// items: the ordered list the template renders (text ids or block objects)
		// resolve: maps one item to its resolved text object ({type, location})
		sortByDistance: function(items, resolve) {

			var position = this.$store.getters['position']

			if (!position || !items || items.length < 2) return items

			var locations = this.$store.getters['locations']
			var drives = this.$store.getters['drives']
			var locationType = this.$constants.text.type.location
			var self = this

			var isLocation = function(item) {

				var text = resolve(item)

				return !!(text && text.type === locationType)

			}

			// miles to a location block: the displayed driving miles once resolved,
			// else straight-line; null for blocks with no coordinate (multiple/label)
			var distanceOf = function(item) {

				var text = resolve(item)

				if (!text || text.type !== locationType) return null

				var location = self.$_.findWhere(locations, { id: text.location })

				if (!location || location.lat === null || location.lat === undefined) return null

				var drive = drives[location.id]

				if (drive && drive.miles !== null && drive.miles !== undefined) return drive.miles

				return geo.haversineMiles(position, location)

			}

			var result = items.slice()
			var i = 0

			while (i < result.length) {

				if (!isLocation(result[i])) {

					i++
					continue

				}

				// gather the contiguous run of location blocks (with or without coords)
				var run = []
				var j = i

				while (j < result.length && isLocation(result[j])) {

					run.push({ item: result[j], index: j, distance: distanceOf(result[j]) })
					j++

				}

				// closest first; coordinate-less blocks (null distance) keep their
				// order and sink to the end; ties break on original position
				run.sort(function(a, b) {

					if (a.distance === null && b.distance === null) return a.index - b.index
					if (a.distance === null) return 1
					if (b.distance === null) return -1
					if (a.distance === b.distance) return a.index - b.index
					return a.distance - b.distance

				})

				for (var k = 0; k < run.length; k++) {

					result[i + k] = run[k].item

				}

				i = j

			}

			return result

		}

	}

}
